import script from "./MoneyInputConfig.vue?vue&type=script&lang=ts"
export * from "./MoneyInputConfig.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__